import React from "react";

export default ({ onChange, value }) => (
  <div className="d-flex flex-row mb-5">
    <p className="text-dark bold mr-3">Post to my Newsfeed:</p>
    <div className="custom-control custom-switch">
      <input type="checkbox" onChange={() => onChange(!value)} className="custom-control-input bg-dark" id="post-switch" />
      <label className="custom-control-label" htmlFor="post-switch"></label>
    </div>
  </div>
);
